import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';

export const useMoveToNotification = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(() => {
    openDeeplink('ably://notifications');
  }, [openDeeplink]);
};
